/* Minxy funnel helpers: ?for= avatar routing, "Is it for me?" cards, size finder, sticky bar. No dependencies. */
(function () {
  var KEYS = ['hiding', '45', 'weightloss', 'mum', 'shift', 'party'];
  function getFor() {
    var v = null;
    try { v = new URLSearchParams(location.search).get('for'); } catch (e) {}
    if (v && KEYS.indexOf(v) > -1) { try { sessionStorage.setItem('mx_for', v); } catch (e) {} return v; }
    try { v = sessionStorage.getItem('mx_for'); } catch (e) {}
    return v && KEYS.indexOf(v) > -1 ? v : null;
  }
  function openCard(key, scroll) {
    var wrap = document.querySelector('[data-mx-for]'); if (!wrap) return;
    wrap.querySelectorAll('[data-mx-chip]').forEach(function (b) {
      b.setAttribute('aria-expanded', b.getAttribute('data-mx-chip') === key ? 'true' : 'false');
    });
    wrap.querySelectorAll('[data-mx-card]').forEach(function (c) {
      c.classList.toggle('is-open', c.getAttribute('data-mx-card') === key);
    });
    if (scroll) { var c = wrap.querySelector('[data-mx-card="' + key + '"]'); if (c) c.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
  }
  function applyFor(key) {
    if (!key) return;
    var h1 = document.querySelector('[data-mx-h1]');
    var map = document.getElementById('mx-h1-map');
    if (h1 && map) { try { var m = JSON.parse(map.textContent); if (m[key]) h1.textContent = m[key]; } catch (e) {} }
    openCard(key, false);
    var row = document.querySelector('[data-mx-tests]');
    if (row) {
      var first = row.querySelector('[data-for~="' + key + '"]');
      if (first && first !== row.firstElementChild) row.insertBefore(first, row.firstElementChild);
    }
    document.querySelectorAll('a[href^="/"]').forEach(function (a) {
      var raw = a.getAttribute('href'); if (raw.indexOf('for=') > -1) return;
      if (raw.indexOf('/products/') < 0 && raw.indexOf('/pages/') < 0) return;
      var u = new URL(raw, location.origin); u.searchParams.set('for', key); a.setAttribute('href', u.pathname + u.search + u.hash);
    });
  }
  /* market subfolder (e.g. /en-gb/): keep visitors in their market when a link is hard-coded as /products/... */
  function localiseLinks() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root === '/') return;
    var base = root.replace(/\/$/, '');
    document.querySelectorAll('a[href^="/products/"],a[href^="/pages/"],a[href^="/collections/"],a[href="/"]').forEach(function (a) {
      a.setAttribute('href', base + a.getAttribute('href'));
    });
  }
  function initFor() {
    document.querySelectorAll('[data-mx-chip]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-mx-chip');
        var open = b.getAttribute('aria-expanded') === 'true';
        openCard(open ? '__none' : key, !open);
      });
    });
  }
  /* size finder: weight decides the size, height only adds the leg-length line */
  function initFinder() {
    var f = document.querySelector('[data-mx-finder]'); if (!f) return;
    var metric = false;
    var out = f.querySelector('[data-mx-out]');
    var rows = []; try { rows = JSON.parse(f.querySelector('[data-mx-rows]').textContent); } catch (e) {}
    function val(n) { var el = f.querySelector('[name="' + n + '"]'); return el ? parseFloat(el.value) || 0 : 0; }
    function calc() {
      var kg = metric ? val('kg') : (val('st') * 6.35029 + val('lb') * 0.453592);
      var cm = metric ? val('cm') : (val('ft') * 30.48 + val('in') * 2.54);
      if (!kg) { out.textContent = ''; return; }
      var hit = null, near = null;
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (kg >= r.min && kg < r.max) { hit = r; if (r.max - kg <= 2 && rows[i + 1]) near = rows[i + 1]; if (kg - r.min <= 2 && rows[i - 1]) near = near || rows[i - 1]; break; }
      }
      if (!hit) { out.textContent = f.getAttribute('data-none'); return; }
      var t = f.getAttribute('data-result').replace('[size]', hit.size);
      if (near) t += ' ' + f.getAttribute('data-between').replace('[a]', hit.size).replace('[b]', near.size);
      if (cm && cm < 160 && f.getAttribute('data-short')) t += ' ' + f.getAttribute('data-short');
      if (cm && cm > 175 && f.getAttribute('data-tall')) t += ' ' + f.getAttribute('data-tall');
      out.textContent = t;
    }
    f.addEventListener('input', calc);
    var tog = f.querySelector('[data-mx-units]');
    if (tog) tog.addEventListener('click', function () {
      metric = !metric;
      f.querySelectorAll('[data-imperial]').forEach(function (e) { e.hidden = metric; });
      f.querySelectorAll('[data-metric]').forEach(function (e) { e.hidden = !metric; });
      tog.textContent = metric ? tog.getAttribute('data-to-imperial') : tog.getAttribute('data-to-metric');
      calc();
    });
  }
  /* sticky bar: visible from the first screen, hidden while the offer is on screen */
  function initSticky() {
    var bar = document.querySelector('[data-mx-sticky]'); if (!bar) return;
    var targets = document.querySelectorAll(bar.getAttribute('data-hide-when') || '#mx-offer');
    var offerVisible = false, scrolled = false, seen = {};
    function upd() { bar.classList.toggle('is-on', !offerVisible && (scrolled || bar.hasAttribute('data-from-top'))); }
    var start = parseFloat(bar.getAttribute('data-start') || '0');
    window.addEventListener('scroll', function () {
      var h = document.documentElement.scrollHeight - innerHeight;
      scrolled = h > 0 ? (scrollY / h) >= start : true; upd();
    }, { passive: true });
    if (targets.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { seen[e.target.id || e.target.className] = e.isIntersecting; });
        offerVisible = Object.keys(seen).some(function (k) { return seen[k]; }); upd();
      }, { threshold: 0 });
      targets.forEach(function (t) { io.observe(t); });
    }
    upd();
  }
  document.addEventListener('DOMContentLoaded', function () {
    localiseLinks(); initFor(); initFinder(); initSticky();
    applyFor(getFor());
  });
})();